import React from "react";
import NavTop from "../../component/NavTop";
import NumberFormat from "react-number-format";
import { FiArrowUpRight, FiArrowDownLeft } from "react-icons/fi";
import ButtonLoading from "../../component/ButtonLoading";
import { toast } from "react-toastify";
import { mutate } from "swr";
import {
  KIND_UTANG,
  KIND_PIUTANG,
  debtCreate,
  useDebtParties,
  useWalletAmount,
} from "../../api";
import "./debt.css";

const DebtAdd = (props) => {
  const initialKind = (() => {
    const search = new URLSearchParams(props.location.search);
    const k = parseInt(search.get("kind"), 10);
    return k === 2 ? KIND_PIUTANG : KIND_UTANG;
  })();

  const { parties } = useDebtParties();
  const { walletAmounts } = useWalletAmount();

  const [kind, setKind] = React.useState(initialKind);
  const [partyMode, setPartyMode] = React.useState("new"); // "new" | "existing"
  const [partyId, setPartyId] = React.useState("");
  const [partyName, setPartyName] = React.useState("");
  const [partyPhone, setPartyPhone] = React.useState("");
  const [amount, setAmount] = React.useState(0);
  const [description, setDescription] = React.useState("");
  const [walletId, setWalletId] = React.useState("");
  const [startedAt, setStartedAt] = React.useState(
    new Date().toISOString().slice(0, 10)
  );
  const [dueDate, setDueDate] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (!walletId && walletAmounts.length > 0) {
      setWalletId(walletAmounts[0].id);
    }
  }, [walletAmounts, walletId]);

  React.useEffect(() => {
    if (parties.length > 0 && partyMode === "new" && !partyName) {
      // start with new mode by default, user can switch to existing
    }
  }, [parties, partyMode, partyName]);

  const submit = async (e) => {
    e.preventDefault();
    if (amount <= 0) return toast.error("Masukkan jumlah");
    if (partyMode === "new" && !partyName.trim())
      return toast.error("Masukkan nama");
    if (partyMode === "existing" && !partyId)
      return toast.error("Pilih counterparty");
    if (!walletId) return toast.error("Pilih wallet");

    setLoading(true);
    try {
      await debtCreate({
        kind,
        partyId: partyMode === "existing" ? partyId : undefined,
        partyName: partyMode === "new" ? partyName.trim() : undefined,
        partyPhone: partyPhone.trim() || undefined,
        originalAmount: amount,
        description: description.trim() || undefined,
        walletId,
        startedAt: new Date(startedAt + "T00:00:00").toISOString(),
        dueDate: dueDate || undefined,
      });
      // Invalidate debt list / summary / parties caches (SWR 0.3 API).
      mutate("/debts/summary");
      mutate("/debts?kind=1");
      mutate("/debts?kind=2");
      mutate("/debt-parties");
      toast.success(kind === KIND_UTANG ? "Utang tercatat" : "Piutang tercatat");
      props.history.push("/debts");
    } catch (err) {}
    setLoading(false);
  };

  return (
    <>
      <NavTop title={kind === KIND_UTANG ? "Catat Utang" : "Catat Piutang"} />
      <div className="main-padding">
        <form className="debt-form" onSubmit={submit} noValidate>
          <div className="kind-toggle">
            <button
              type="button"
              className={kind === KIND_UTANG ? "selected" : ""}
              data-kind="utang"
              onClick={() => setKind(KIND_UTANG)}
            >
              <FiArrowUpRight size="1.3em" /> Utang
              <small>Pinjam uang</small>
            </button>
            <button
              type="button"
              className={kind === KIND_PIUTANG ? "selected" : ""}
              data-kind="piutang"
              onClick={() => setKind(KIND_PIUTANG)}
            >
              <FiArrowDownLeft size="1.3em" /> Piutang
              <small>Saya yang meminjamkan</small>
            </button>
          </div>

          <div className="form-group">
            <label>Counterparty</label>
            {parties.length > 0 && (
              <div className="mb-2" style={{ fontSize: "0.85rem" }}>
                <label className="mr-3">
                  <input
                    type="radio"
                    checked={partyMode === "new"}
                    onChange={() => setPartyMode("new")}
                  />{" "}
                  Baru
                </label>
                <label>
                  <input
                    type="radio"
                    checked={partyMode === "existing"}
                    onChange={() => setPartyMode("existing")}
                  />{" "}
                  Pilih dari daftar
                </label>
              </div>
            )}
            {partyMode === "new" ? (
              <>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Nama"
                  value={partyName}
                  onChange={(e) => setPartyName(e.target.value)}
                />
                <input
                  type="text"
                  className="form-control mt-2"
                  placeholder="No. HP (opsional)"
                  value={partyPhone}
                  onChange={(e) => setPartyPhone(e.target.value)}
                />
              </>
            ) : (
              <select
                className="form-control"
                value={partyId}
                onChange={(e) => setPartyId(e.target.value)}
              >
                <option value="">— Pilih —</option>
                {parties.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.name}
                    {p.phone ? ` (${p.phone})` : ""}
                  </option>
                ))}
              </select>
            )}
          </div>

          <div className="form-group">
            <label>Jumlah</label>
            <NumberFormat
              prefix={"Rp "}
              value={amount}
              className="form-control"
              thousandSeparator={true}
              onValueChange={(v) => setAmount(v.floatValue || 0)}
            />
          </div>

          <div className="form-group">
            <label>Wallet</label>
            <select
              className="form-control"
              value={walletId}
              onChange={(e) => setWalletId(e.target.value)}
            >
              {walletAmounts.map((w) => (
                <option key={w.id} value={w.id}>
                  {w.name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Tanggal mulai</label>
            <input
              type="date"
              className="form-control"
              value={startedAt}
              onChange={(e) => setStartedAt(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>Jatuh tempo (opsional)</label>
            <input
              type="date"
              className="form-control"
              value={dueDate}
              onChange={(e) => setDueDate(e.target.value)}
              min={startedAt}
            />
          </div>

          <div className="form-group">
            <label>Keterangan (opsional)</label>
            <textarea
              className="form-control"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows="2"
              placeholder="mis. pinjam buat modal usaha"
            />
          </div>

          {loading ? (
            <ButtonLoading />
          ) : (
            <button className="btn btn-block btn-primary mt-3">
              Simpan
            </button>
          )}
        </form>
      </div>
    </>
  );
};

export default DebtAdd;
